// [목적] GET /rag/concepts — 5대 여행 컨셉 칩(반려동반/맛집/한적한/캠핑/MZ감성) 목록 조회 클라이언트
// [이유] FlowLine 83963a6b(rag-search-quality 과업1 FE 후속): 채팅 추천 칩이 mocks/fixtures/design-mock.ts
//        SUGGEST_CHIPS 하드코딩 상수였던 문제 — BE GET /rag/concepts(apps/api/src/modules/rag/controllers/
//        concepts.controller.ts, 구현·검증 완료)가 5종 결정적 목록의 단일 소스가 되고, FE 는
//        packages/types/src/concept.ts 공유 zod 스키마(conceptListResponseSchema)로 응답을 파싱해 그대로
//        칩으로 렌더한다(CLAUDE §6-5: 외부 응답은 zod 파싱 후 사용). festivals.client.ts 와 동일한
//        fetchWithEnvelope + 공유 스키마 재사용 패턴.
// [사이드 이팩트] 없음(조회 전용 GET, 공개 엔드포인트 — 인증/CSRF 불요).
// [수정 시 고려사항] BE 응답 계약(5종 고정 순서=칩 노출 순서) 변경 시 packages/types/src/concept.ts 가
//                   SoT — 이 파일은 재사용만 담당. concept.id 값 집합은 apps/api rag/dto/slot.schema.ts
//                   ConceptEnum 과 1:1 동일해야 useChatFlow.ts 의 슬롯 제출(concept 필드)이 유효하다.

import { conceptListResponseSchema, type ConceptItem } from '@gangwoncanvas/types';

import { fetchWithEnvelope } from './http.js';

export type Concept = ConceptItem;

/**
 * [목적] GET /rag/concepts — 5대 컨셉 칩 목록 조회(공개, 서버 결정적 상수)
 * [이유] ChatPage/ChatMobile 첫 진입 추천 칩의 데이터 소스.
 * [사이드 이팩트] 없음(조회 전용).
 * [수정 시 고려사항] 응답이 5건이 아니어도 파싱은 통과(스키마가 개수를 강제하지 않음) — 호출부는 배열 길이에
 *                   의존하지 않고 그대로 map 렌더한다.
 */
export async function listConcepts(): Promise<Concept[]> {
  const data = await fetchWithEnvelope<unknown>('/rag/concepts');
  return conceptListResponseSchema.parse(data);
}
